import React, { Component } from 'react';
import { Col } from "reactstrap";


class UserPopupWindow extends Component {

  componentDidMount() {
    this.scLauncher = document.querySelector('#sc-launcher');
    
    this.scLauncher.addEventListener('click', this.interceptLauncherClick);
  }

  componentWillUnmount() {
    this.scLauncher.removeEventListener('click', this.interceptLauncherClick);
  }

  interceptLauncherClick = (e) => {
    const { isOpen } = this.props;  
    const clickedOutside = !this.emojiPopup.contains(e.target) && isOpen;
    clickedOutside && this.props.onClickedOutside(e);
    //document.querySelector("#search-user").value = "";
  }

  render() {
    const { isOpen, children } = this.props;
    return (

      <div className="sc-popup-window botstyle" ref={e => this.emojiPopup = e}>
        <Col xs={12} sm={12} >
        <div style={{marginRight:220,maxWidth:400,width:400,maxHeight:200,height:200}} className={`sc-popup-window--cointainer ${isOpen ? '' : 'closed'}`}>
          {/*<input id="search-user"
          style={{width:"100%"}}
            onChange={this.props.onInputChange}
            className="sc-popup-window--search"
            placeholder="Search user..."
          
          />*/}
          {children}
        </div>
        </Col>

      </div>
    );
  }
}

export default UserPopupWindow;
